class CowboyCarousel extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.destroy();
  }

  init() {
    if (typeof Swiper === 'undefined') return;
    if (this.swiper) return;

    const slider = this.querySelector('.image-link-carousel__swiper');
    if (!slider) return;

    const slideCount = this.querySelectorAll('.swiper-slide').length;
    const enableLoop = this.dataset.enableLoop === 'true' && slideCount > 1;
    const enablePagination = this.dataset.enablePagination === 'true' && slideCount > 1;
    const enableAutoplay = this.dataset.enableAutoplay === 'true' && slideCount > 1;

    const mobileSlides = parseFloat(this.dataset.mobileSlides || '1.2');
    const tabletSlides = parseFloat(this.dataset.tabletSlides || '2.4');
    const desktopSlides = parseFloat(this.dataset.desktopSlides || '4');
    const spaceMobile = parseInt(this.dataset.spaceMobile || '12', 10);
    const spaceDesktop = parseInt(this.dataset.spaceDesktop || '20', 10);
    const slideDuration = parseInt(this.dataset.slideDuration || '5000', 10);

    const paginationEl = this.querySelector('.swiper-pagination');

    this.swiper = new Swiper(slider, {
      loop: enableLoop,
      watchOverflow: true,
      grabCursor: true,
      slidesPerView: mobileSlides,
      spaceBetween: spaceMobile,
      speed: 500,
      allowTouchMove: slideCount > 1,
      pagination: enablePagination && paginationEl
        ? {
            el: paginationEl,
            clickable: true
          }
        : false,
      autoplay: enableAutoplay
        ? {
            delay: slideDuration,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }
        : false,
      breakpoints: {
        768: {
          slidesPerView: tabletSlides,
          spaceBetween: spaceDesktop
        },
        990: {
          slidesPerView: desktopSlides,
          spaceBetween: spaceDesktop
        }
      }
    });
  }

  destroy() {
    if (!this.swiper) return;
    this.swiper.destroy(true, true);
    this.swiper = null;
  }
}

if (!customElements.get('cowboy-carousel')) {
  customElements.define('cowboy-carousel', CowboyCarousel);
}
